import {
  CloseButton,
  DELETE_WARNING,
  DropDownMenu,
  MenuItemType,
  Stack,
  Typography,
  UpdateButton,
} from "@compass/core";
import { SubmitButton } from "components";
import { LkTextingQueueStatusId, Permission, PermissionAction, TextingQueueDetailDto } from "generated/openApi";
import { isAuthorized } from "services";
import { TextingStatusChip } from "../TextingStatusChip";

export const TextingQueueDetailPageHeader = (props: {
  textingQueue: TextingQueueDetailDto;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  unsavedChanges: boolean;
  save: () => void;
  deleteQueue: () => void;
}) => {
  const isScheduled = props.textingQueue.statusId === LkTextingQueueStatusId.Scheduled;
  const menuItems: MenuItemType[] = [];

  if (isScheduled && isAuthorized(Permission.Texting, PermissionAction.Delete)) {
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: () => {
        if (window.confirm(DELETE_WARNING)) props.deleteQueue();
      },
    });
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" spacing="sm" alignItems="center">
        <Typography variant="inherit">
          {props.textingQueue.name || `Texting Queue #${props.textingQueue.id}`}
        </Typography>
        {props.textingQueue.status && <TextingStatusChip status={props.textingQueue.status} />}
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" spacing="sm" alignItems="center">
        <CloseButton confirm={props.isEditing && props.unsavedChanges} />
        {!props.isEditing && isScheduled && isAuthorized(Permission.Texting, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.setIsEditing(true)} />
        )}
        {props.isEditing && (
          <SubmitButton onClick={props.save} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
